import { CalendarPlus } from "lucide-react";
import { downloadIcs } from "@/lib/calendar-helpers";

interface Props {
  title: string;
  description: string;
  location: string;
  startDate: Date;
  endDate: Date;
}

const AddToCalendarButton = ({ title, description, location, startDate, endDate }: Props) => {
  const handleClick = () => {
    downloadIcs({
      title,
      description,
      location,
      startDate,
      endDate,
      url: window.location.href,
    });
  };

  return (
    <button
      onClick={handleClick}
      className="flex h-10 flex-1 items-center justify-center gap-2 rounded-lg border border-secondary bg-card text-sm font-medium text-secondary"
    >
      <CalendarPlus size={18} />
      Add to Calendar
    </button>
  );
};

export default AddToCalendarButton;
